<template>
  <SideModal
    location="left"
    close-on-overlay-click
    :show="show"
    @update:show="$emit('update:show', $event)"
  >
    <div class="modal-container">
      <div class="modal-top">
        <Typography color="primary" weight="600" size="1.25rem">Create Event</Typography>
        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <form @submit.prevent="save" class="modal-body">
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Event Name"
            v-model="state.name"
            data-cy="add-event-name"
          ></v-text-field>
          <FormValidate
            :validate="state.name"
            :regex="/.{1,50}/"
            title="Team Name must have length of 1 - 50 characters"
          ></FormValidate>
        </div>
        <div>
          <Typography color="primary" weight="600" size="1.2rem" tag="div" class="pb-3"
            >Reservations</Typography
          >
          <DatePicker
            class="custom-input datetime"
            density="comfortable"
            type="datetime-local"
            label="Open"
            color="primary"
            v-model="state.openTime"
            data-cy="add-event-open"
          ></DatePicker>
        </div>
        <div>
          <DatePicker
            class="custom-input datetime"
            density="comfortable"
            type="datetime-local"
            label="Close"
            color="primary"
            v-model="state.closeTime"
            data-cy="add-event-close"
          ></DatePicker>
        </div>
        <div>
          <v-btn
            width="100%"
            type="submit"
            :loading="state.loadingSave"
            style="text-transform: capitalize"
            data-cy="add-event-save"
            >Save</v-btn
          >
        </div>
      </form>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import DatePicker from "@/components/datePicker.vue";
import FormValidate from "@/components/formValidate.vue";
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import router from "@/router";
import { useConferenceStore } from "@/stores/teacher/conference";
import dayjs from "dayjs";
import { reactive } from "vue";

defineProps<{
  show: boolean;
}>();

defineEmits<{
  (event: "update:show", val: boolean);
}>();

const confStore = useConferenceStore();

const state = reactive({
  loadingSave: false,
  name: "",
  openTime: new Date(),
  closeTime: dayjs().add(1, "day").toDate()
});

const save = async () => {
  state.loadingSave = true;
  const res = await confStore.addConference({
    conference_name: state.name,
    open_tstamp: dayjs(state.openTime).format(`YYYY-MM-DD HH:mm:ss`),
    closed_tstamp: dayjs(state.closeTime).format(`YYYY-MM-DD HH:mm:ss`)
  });
  state.loadingSave = false;
  if (res?.conference_id) {
    router.push({
      name: "school-edit-events",
      params: {
        eventId: res.conference_id
      }
    });
  }
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
